import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useState } from "react";
import CommonModal from "../../../../../../../components/modal/common";
import { InfoCircleOutlined } from "@ant-design/icons";
import FormInput from "../../../../../../../components/form-input-login/FormInput";
import { Typography } from "antd";
import { verifyPassword } from "../../../../../../../service/auth";
import { deleteReportAttendance } from "../../../../../../../service/setting-attendance";

interface IProps {
  IsOpenDelete: boolean;
  idReport: string;
  IsConfirmDelete: boolean;
  handleConfirmDelete: () => void;
  onCloseModal: () => void;
  handleNotice: (item: string) => void;
  title: string;
}
const ReportCheckInModal = ({
  IsOpenDelete,
  idReport,
  handleConfirmDelete,
  handleNotice,
  onCloseModal,
  title,
  IsConfirmDelete,
}: IProps) => {
  const { t } = useTranslation();
  const [password, setPassWord] = useState("");
  const [checkPass, setCheckPassword] = useState<boolean>(true);

  const handleChange = (value: any) => {
    setPassWord(value);
  };

  const handleSubmitDelete = async () => {
    try {
      const response = await verifyPassword({ password });
      const { data } = response;
      if (data?.statusCode === 200) {
        const res = await deleteReportAttendance(idReport)
        handleNotice(t("Xoá báo cáo thành công", "Xoá báo cáo thành công"));
        onCloseModal()
      } else {
        setCheckPassword(false);
      }
    } catch (error) {
      setCheckPassword(false);
      console.log(error);
    }
  };
  const cancelModal = () => {
    setPassWord("")
    onCloseModal()
    setCheckPassword(true);
  }
  return (
    <div>
      <CommonModal
        open={IsOpenDelete}
        title={`${t("Xoá báo cáo điểm danh", "Xoá báo cáo điểm danh")} ${title}`}
        desc={
          <div>
            {t("Khoá học đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá báo cáo này?", "Khoá học đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá báo cáo này?")}
          </div>
        }
        closeIcon={true}
        okText={t("Xác nhận", "Xác nhận")}
        cancelText={t("Huỷ", "Huỷ")}
        icon={
          <InfoCircleOutlined
            style={{ color: "#FFC53D", marginRight: "10px" }}
          />
        }
        confirm={handleConfirmDelete}
        closeModal={onCloseModal}
        className={""}
      />
      <CommonModal
        open={IsConfirmDelete}
        title={`${t("Xoá báo cáo điểm danh", "Xoá báo cáo điểm danh")} ${title}`}
        desc={
          <div>
            <FormInput
              type="password"
              value={password}
              title={t("Mã UserID", "Mã UserID")}
              onChange={handleChange}
              isPassword
            />
          </div>
        }
        closeIcon={true}
        okText={t("Xoá báo cáo", "Xoá báo cáo")}
        cancelText={t("Huỷ", "Huỷ")}
        icon={
          <InfoCircleOutlined
            style={{ color: "#FFC53D", marginRight: "10px" }}
          />
        }
        confirm={handleSubmitDelete}
        closeModal={cancelModal}
        className={"!w-[465px] report-delete-confirm"}
      />
    </div>
  );
};

export default ReportCheckInModal;
